import React, {Component} from "react";
import PropTypes from "prop-types";

class Drawer extends Component {
    constructor(props){
        super(props);
        this.close = this.close.bind(this);
    }

    close(){
        const {onClose} = this.props;
        onClose();
    }

    render(){
        const {children, footer, show} = this.props;
        return (
            <aside className={"drawer" + (show ? " drawer--is-open" : "")} aria-hidden={! show}>
                <div className={"drawer__panel"} tabIndex={-1} aria-expanded={show}>
                    <button onClick={this.close} className="drawer__close btn btn--transparent" aria-label="close"><i
                        className="icon-cme-card-close icon--medium"></i></button>
                    <div className={"drawer__body"} role={"dialog"}>
                        {show && children}
                    </div>
                    <footer className={"drawer__footer"}>
                        {footer}
                    </footer>
                </div>
            </aside>
        );
    }
}

Drawer.propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
    footer: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.element
    ])
};

export default Drawer;